<template>
<div class="container-body login-body-color" >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5 login-border-radius">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6">
                <img src="./loginPageBanner.png" class="login-logo" alt="logo" />
              </div>
              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-center">
                  <span>
                  {{ $t("ユーザーIDのリセット") }}
                </span>
                  </div>
                  <br />
                  <form class="user"  @submit.prevent="login" >
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control form-control-user"
                        id="exampleInputEmail"
                        v-model.trim="$v.form.userid.$model"
                        aria-describedby="emailHelp"
                        placeholder="IDのリセット"
                        @keydown.space="(event) => event.preventDefault()"
                      />
                      <show-errors :control="$v.form.userid" :field="$t('MANDATORY')" />
                    </div>
                     <br/>
                     <div class="text-center">
                       <span>
                  {{ $t("パスワードのリセット") }}
                </span>
                 
                  </div>
                    <br />
                    <div class="form-group">
                      <input
                        type="password"
                        class="form-control form-control-user"
                        id="exampleInputEmail"
                        v-model.trim="$v.form.password.$model"
                        aria-describedby="emailHelp"
                        :placeholder="$t('NEWPASSWORD')"
                      />
                      <show-errors :control="$v.form.password" :field="$t('MANDATORY')" />
                    </div>
                    <div class="form-group">
                      <input
                        type="password"
                        v-model.trim="$v.form.repeatPassword.$model"
                        class="form-control form-control-user"
                        id="exampleInputPassword"
                        placeholder="新しいパスワード（確認）"
                      />
                      <show-errors
                        :control="$v.form.repeatPassword"
                        :field="$t('IDENTICALPASSWORD')"
                      />
                    </div>
                    <button
                      class="btn btn-primary btn-user btn-block"
                      type="submit"
                      
                    >
                      リセット
                      <span
                        v-if="submitted"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span class="sr-only">Loading...</span>
                    </button>
                      <br />
                   
                  </form>
                 
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { required, sameAs, helpers } from "vuelidate/lib/validators";
import ShowErrors from "../../../components/ShowErrors";
import { mapGetters } from "vuex";
import { RESET_PASSWORD } from "@/store/actions.type";
const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{10,}$/;
const specialPassword = helpers.regex("specialPassword", regex);

export default {
  name: "FirstTimeLogin",
  components: { ShowErrors },
  data() {
    return {
      form: {
        password: "",
        repeatPassword: "",
        userid: localStorage.getItem("userid")
      },
      submitted: false
    };
  },
  validations: {
    form: {
      password: {
        required,
        specialPassword
      },
      repeatPassword: {
        sameAsPassword: sameAs("password")
      },
      userid: { required }
    }
  },
  methods: {
    login() {
      this.$toast.removeAll();
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.form.$invalid) {
        this.$store
          .dispatch(RESET_PASSWORD, {
            password: this.form.password,
            userid: this.form.userid
          })
          .then(data => {
            localStorage.userid = this.form.userid;
              this.submitted = false;

            if (data.success) {
              this.$toast.success({
                message: data.message
              });
              this.$router.push("/login");
            }else{
               this.$toast.error({
                message: data.message
              });
            }
          });
      } else {
        this.submitted = false;
      }
      /* If valid it will navigate to dashboard */
      // this.$router.push("/dashboard");
    }
  },
  created() {
    this.$toast.removeAll();
  },
  computed: {
    ...mapGetters([""])
  }
};
</script>
<style>
.IconLogo {
  height: 18%;
  margin: 5%;
}
.container-body {
            position: absolute;
            width: 100%;
            min-height: 100%;
            left: 0;
            top: 0;
        }
</style>
